<template>
  <div id="DetallesConsultaDireccion_div">
    <div id="TituloConsultaDireccion_div" class="w-100">
      <h1 style="margin-bottom: 0px;">Cédula de Expediente {{ numeroExpediente }}</h1>
      <!-- <h3 style="margin-top: 0px;">Detalles de cédula</h3> -->
    </div>
    <div id="encabezado-contenedor-contenido" class="form-inline mt-3">
      <div class="flex-grow-1"><button type="button" @click="regresarAVistaPrincipal" class="btn btn-primary"><i class="fas fa-long-arrow-alt-left" style="font-size:20px;"></i></button></div>
      <div class="flex-grow-1" style="padding-left: 11em; color: #fff !important;"><h4>Detalles de cédula</h4></div>
      <div class="flex-grow-1"></div>
    </div>
    <div id="contendor-detalles" class="col-12 contenedor-informacion">
      <div class="d-flex justify-content-between mt-3">
        <div style="width: 29%">
          <div class="contenedor-color-negro">
            <InformacionBasicaDeCedula v-if="this.campoRequeridoEsValido(cedulaBD)"
              :titulo="'Información'" 
              :cedula="cedulaBD"
              :ref="infBasicaCedula.REF"></InformacionBasicaDeCedula>
            <!-- <div class="text-right">
              <button class="btn btn-primary" id="historialAcuerdo_btn" @click="verHistorialDeAcuerdo"><i class="fas fa-history"></i>&nbsp;&nbsp;Historial de acuerdo</button>
            </div> -->
          </div>
        </div>     
        <div id="ContenidoVistaDeInformacion_div" style="width: 69%">
          <div id="contenedor-tab">
            <ul class="nav nav-tabs" id="nav-tab-formulario-documentos" role="tablist">
              <li class="nav-item">
                <a class="nav-link active" @click="actualizarVisoresDeDocumentos" id="documento-cedula-tab" data-toggle="tab" href="#documento-cedula" role="tab" aria-controls="documento-cedula" aria-selected="true"><i class="fas fa-folder-open"></i>&nbsp;Cédula</a>
              </li>
              <li class="nav-item">
                <a class="nav-link " @click="actualizarVisoresDeDocumentos" id="documento-acuerdo-tab" data-toggle="tab" href="#documento-acuerdo" role="tab" aria-controls="documento-acuerdo" aria-selected="true"><i class="fas fa-folder-open"></i>&nbsp;Acuerdo</a>
              </li>
              <li class="nav-item">
                <a class="nav-link " @click="actualizarVisoresDeDocumentos" id="documento-resultado-tab" data-toggle="tab" href="#documento-resultado" role="tab" aria-controls="documento-resultado" aria-selected="true"><i class="fas fa-folder-open"></i>&nbsp;Resultado</a>
              </li>
              <li class="nav-item">
                <a class="nav-link " @click="actualizarVisoresDeDocumentos" id="regresarCedula-consulta-tab" data-toggle="tab" href="#regresarCedula-consulta" role="tab" aria-controls="regresarCedula-consulta" aria-selected="true"><i class="fas fa-undo-alt"></i>&nbsp;Regresar cédula a juzgado</a>
              </li>
              <li class="nav-item">
                <a class="nav-link " @click="actualizarVisoresDeDocumentos" id="enviarCedula-consulta-tab" data-toggle="tab" href="#enviarCedula-consulta" role="tab" aria-controls="enviarCedula-consulta" aria-selected="true"><i class="fas fa-paper-plane"></i>&nbsp;Enviar cédula</a>
              </li>
            </ul>
            <div class="nav_tab_formularios">
              <div class="tab-content">
                <div class="tab-pane fade show active" id="documento-cedula" role="tabpanel" aria-labelledby="documento-cedula-tab">
                  <div class="area">
                    <div id="informacion-fechas-cedula">
                      <div class="d-flex flex-sm-row flex-column">
                        <div class="form-group mr-sm-3">
                          <h6 for="inf_fead2">Fecha de creación</h6>
                          <input id="inf_fead2" class="form-control" type="text" v-model="fechaCreacion" readonly />
                        </div>
                        <div class="form-group mr-sm-3">
                          <h6 for="inf_fead2">Fecha de audiencia</h6>
                          <input id="inf_fead2" class="form-control" type="text" v-model="fechaAudiencia" readonly />
                        </div>
                      </div>
                      <div id="informacion-cedula-direccion" class="d-flex flex-sm-row flex-column">
                        <div class="form-group mr-sm-3">
                          <h6 for="inf_fead">Fecha de envío a dirección</h6>
                          <input id="inf_fead" class="form-control" type="text" v-model="fechaEnvioDireccion" readonly />
                        </div>
                        <div class="form-group">
                          <h6 for="inf_prd">Prioridad</h6>
                          <div id="inf_prd" class="form-inline">
                            <input class="form-control text-center" style="width: 5rem;" type="text" v-model="prioridadCedula" readonly />
                            <div v-if="this.campoRequeridoEsValido(iconoPrioridad)" v-html="iconoPrioridad" class="ml-sm-2"></div>
                          </div>
                        </div>
                      </div>
                      <div id="informacion-asignacion-cedula" class="d-flex flex-sm-row flex-column">
                        <div class="form-group mr-sm-3">
                          <h6 for="inf_feasg">Fecha de asignación</h6>
                          <input id="inf_feasg" class="form-control" type="text" v-model="fechaAsignacion" readonly />
                        </div>
                        <div class="form-group flex-grow-1">
                          <h6 for="inf_nnot">Notificador</h6>
                          <input id="inf_nnot" class="form-control" type="text" v-model="nombreNotificador" readonly />
                        </div>
                      </div>
                      <div class="form-group" id="seccion-visor-domicilio">
                        <div class="form-inline mb-2">
                          <h6 for="inf_fead2" class="mr-2">Domicilio</h6>
                          <button v-if="this.campoRequeridoEsValido(domicilio) && !domicilioConFraccionamientoFueraDeCatalogo" type="button" class="btn btn-sm btn-light" @click="evtMostrarVisorDomicilio"><i :class="(!visorDomicilio.mostrar) ? 'fas fa-eye' : 'fas fa-eye-slash'"></i></button>
                        </div>
                        <input id="inf_fead2" class="form-control" type="text" v-model="domicilio" readonly />
                        <div v-if="visorDomicilio.mostrar" id="contenedor-mapa">
                          <CMapaDeDomicilios 
                            :ref="visorDomicilio.REF"
                            :idMapa="visorDomicilio.ID"
                            :posicionOrigenMapa="visorDomicilio.POSICION_ORIGEN"
                            :acercamientoInicialMapa="visorDomicilio.ACERCAMIENTO"></CMapaDeDomicilios>
                        </div>
                      </div>
                      <div class="form-group">
                        <h6>Documento</h6>
                        <div class="input-group">
                          <input class="form-control" type="text" v-model="nombreArchivoDeCedula" readonly />
                          <div class="input-group-append">
                            <span class="input-group-text" id="basic-addon2"><span class="fas fa-file"></span></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="form-group col-12" id="documentos_div" v-for="(documento, index) in cedula.Documentos" :key="index" @click="verDocumento">
                      <div class="input-group mb-3">
                        <input class="form-control" type="text" v-model="documento.Nombre" disabled />
                        <div class="input-group-append">
                          <span class="input-group-text" id="basic-addon2"><span class="fas fa-file"></span></span>
                        </div>
                      </div>
                    </div>    -->               
                  </div>
                  <div id="visor-documento-cedula" class="mt-3">
                    <PDFDocument :url="visorDocumentoCedula.url" :height="visorDocumentoCedula.height" :key="'VDC-KEY' + visorDocumentoCedula.contRender" />
                  </div>
                </div>
                <div class="tab-pane fade" id="documento-acuerdo" role="tabpanel" aria-labelledby="documento-acuerdo-tab">
                  <div v-show="acuerdosDeCedulaBD.length > 0">
                    <div style="background-color:var(--verde-pj-100); padding: 8px;">
                      <div class="d-flex justify-content-center">
                        <i class="fas fa-clipboard-list mr-sm-2" style="font-size: 25px;"></i>
                        <div class="align-content-center">
                          <h5>Acuerdos de cédula</h5>
                        </div>
                      </div>
                    </div>
                    <div class="area">
                      <TablaGenericaCedulas class="table-responsive"
                        :idDelInput="'t-acuerdos-vddc'" 
                        :encabezadosColumnas="encabezadosAcuerdos" 
                        :accionesEnTabla="tablaAccionesAcuerdos" 
                        :listaDeCedulas="acuerdosDeCedulaBD"
                        :conResponsive="true"
                        v-on:accionFuncionDetalles="evtDetallesHistorial"
                        :ref="REF_T_ACUERDOS"></TablaGenericaCedulas>
                    </div>
                  </div>
                  <div v-show="acuerdosDeCedulaBD.length < 1">
                    <h4 class="text-center">SIN ACUERDOS</h4>
                  </div>
                </div>
                <div class="tab-pane fade" id="documento-resultado" role="tabpanel" aria-labelledby="documento-resultado-tab">
                  <div class="area">
                    <div class="form-group d-flex justify-content-end">
                      <button v-if="this.campoRequeridoEsValido(this.cedulaBD.Resultado) && !esNotificador && !this.campoRequeridoEsValido(this.cedulaBD.FechaDeEnvioAJuzgado)" 
                        @click="mostrarConfirmacionEliminarResultadoDeCedula({ mostrar: true })" type="button" class="btn btn-sm btn-danger"><i class="fas fa-minus-square"></i>&nbsp;&nbsp;Eliminar Resultado</button>
                    </div>
                    <div class="d-flex flex-sm-row flex-column">
                      <div class="form-group mr-sm-3">
                        <h6>Fecha de resultado</h6>
                        <input class="form-control" type="text" v-model="fechaResultado" readonly />
                      </div>
                      <div class="form-group mr-sm-3 flex-grow-1">
                        <h6>Tipo de resultado</h6>
                        <input class="form-control" type="text" v-model="tipoResultado" readonly />
                      </div>
                    </div>
                    <div v-if="this.campoRequeridoEsValido(tipoRazon)" class="form-group">
                      <h6>Tipo de razón</h6>
                      <textarea rows="2" class="form-control" v-model="tipoRazon" readonly />
                    </div>
                    <div v-if="this.campoRequeridoEsValido(observacionesResultado)" class="form-group">
                       <h6>Observaciones</h6>
                       <textarea rows="2" class="form-control" v-model="observacionesResultado" readonly />
                    </div>
                    <div v-show="documentoResultado.length > 0" class="form-group">
                      <h6>Documentos de resultado {{ vaDocResultado}}</h6>
                      <TablaGenericaCedulas class="table-responsive"
                          :idDelInput="'t-anexos-vddc'" 
                          :encabezadosColumnas="encabezadosColumnas" 
                          :accionesEnTabla="tablaAcciones" 
                          :listaDeCedulas="documentoResultado"
                          :ref="REF_T_ANEXOS"></TablaGenericaCedulas>
                    </div>
                  </div>
                  <div v-for="(documento,index) in documentosResultadoCompleto" id="visor-documentos-resultado" :key="'contVdrVDDC' + index">
                    <div class="mt-3" v-show="docResultadoSeleccionado == index">
                      <PDFDocument
                        :url="(campoRequeridoEsValido(documento.tipo)) ? cedulaBD.Resultado.ArchivoResultado_Ruta : null" 
                        :height="'516px'" 
                        :key="'vdrVDDC' + index + visorResultado.contRender"
                        :ArchivoAConvertir="(!campoRequeridoEsValido(documento.tipo)) ? documento.archivo : null" />
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="regresarCedula-consulta" role="tabpanel" aria-labelledby="regresarCedula-consulta-tab">
                  <div class="area">
                    <h5 style="color: black !important;">Formulario regreso de cédula</h5>
                    <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;"/>
                    <div class="form-group" id="ObservacionesResultado_div">
                      <div class="form-group">
                        <h6>Motivo's (opcional)</h6>
                        <textarea v-model="motivosDeRegreso" rows="6" class="form-control"></textarea>
                      </div>
                      <div class="text-right">
                        <button @click="evtRegresarCedulaAJuzgado" class="btn btn-primary" id="regresarCedula_btn"><i class="fas fa-undo-alt"></i>&nbsp;&nbsp;Regresar</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="enviarCedula-consulta" role="tabpanel" aria-labelledby="enviarCedula-consulta-tab">
                  <div class="area container-fluid">
                    <h5>Envió de cédula a juzgado</h5>
                    <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;"/>
                    <div v-if="fechaDeEnvioJuzgado == null" id="detalles-formulario-envio" class="row form-inline">
                      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pl-3 pt-4"> 
                        <div class="form-inline">
                          <h6 class="mr-2">Fecha de envió: </h6>
                          <input type="date" v-model="formularioEnvioAJuzgado.fechaDeEnvioJuzgado" class="form-control" />
                        </div>
                      </div>
                      <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pl-3 pt-4">
                        <button @click="iniciarProcesoDeEnvioAJuzgado" type="button" class="btn btn-primary texto-ajustable-btn"><i class="fas fa-paper-plane"></i>&nbsp;&nbsp;Enviar</button>
                      </div>
                    </div>
                    <div v-if="fechaDeEnvioJuzgado != null" id="detalles-formulario-envio" class="row form-inline">
                      <i class="fas fa-info-circle col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-3 pt-1">&nbsp;La cedula ya fue enviada al juzgado</i>
                      <div class="form-inline col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-3 pt-4">
                        <h6 for="inf_fead_jz" class="mr-2">Fecha de envío a juzgado</h6>
                        <input id="inf_fead_jz" class="form-control" type="text" v-model="fechaDeEnvioJuzgado" readonly />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL COFIRMACION -->
    <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-informativo">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">Mensaje del sistema</h5>
          </div>
          <div class="modal-body pl-4 pr-4">
            <div class="form-group">
                <h6>Se eliminaran anexos y archivos relacionados al resultado,<br>¿Deseas continuar?</h6>
            </div>
            <div class="row mt-4">
                <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary mr-2" @click="eliminarResultadoDeCedula"><i class="fas fa-check"></i>&nbsp;&nbsp;Confirmar</button></div>
                <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary" @click="mostrarConfirmacionEliminarResultadoDeCedula({ mostrar: false })"><i class="fas fa-times"></i>&nbsp;&nbsp;Cancelar</button></div>
            </div>
          </div>             
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import sistemas from '@/../static/js/sistemas'
  import PDFDocument from '@/../src/components/Comunes/PDFDocument'
  import router from '@/router/index'
  import comun from "@/../static/js/comun"
  import api from '@/../static/js/api'
  import axios from 'axios'
  import CMapaDeDomicilios from '../../Comun/CMapaDeDomicilios.vue'
  import { mapActions } from 'vuex'

  export default {
    components: {
      InformacionBasicaDeCedula: sistemas.SINOJ.CInformacionBasicaDeCedula,
      PDFDocument,
      TablaGenericaCedulas: sistemas.SINOJ.CTablaGenericaCedulas,
      CMapaDeDomicilios: CMapaDeDomicilios
    },
    data() {
      return {
        enumeraciones,
        FORMATO_FECHA: "DD/MM/YYYY HH:mm:ss",
        ID_DETALLES_C: 'DetalllesCedulaVDC',
        cedulaBD: null,
        visorDocumentoCedula: {
          url: '',
          height: '516px',
          contRender: 0
        },     
        ATRIBUTO_FILTROS: 'filtrosPrevios',
        ATRIBUTO_CEDULA: 'cedulaSeleccionada',
        fechaEnvioDireccion: null,
        prioridadCedula: null,
        iconoPrioridad: null,
        fechaAsignacion: null,
        fechaCreacion: null,
        domicilio: null,
        fechaAudiencia: 'Sin fecha de audiencia',
        nombreNotificador: null,
        nombreArchivoDeCedula: 'La cédula no cuenta con un archivo.',
        fechaResultado: 'Sin fecha de resultado',
        tipoResultado: 'Sin resultado',
        tipoRazon: null,
        observacionesResultado: null,
        REF_T_ANEXOS: 'refAnexosVDDC',
        encabezadosAcuerdos: ['Folio', 'Extracto', 'Fecha de publicación','Fecha de audiencia','Acuerdo principal',''],
        tablaAccionesAcuerdos: { motrarAcciones: true, check: false, eliminar: false, detalles: true, ver: false },
        REF_T_ACUERDOS: 'refAcuerdosVDDC',
        encabezadosColumnas: ['#', 'Tipo', 'Nombre'],
        tablaAcciones: { motrarAcciones: false, check: false, eliminar: false, detalles: false, ver: false },
        contAnexos: 0,
        documentoResultado: [],
        documentosResultadoCompleto: [],
        docResultadoSeleccionado: 0,
        vaDocResultado: '',
        acuerdosDeCedulaBD: [],
        numeroExpediente: '',
        motivosDeRegreso: null,
        formularioEnvioAJuzgado: {
          fechaDeEnvioJuzgado: moment().format('YYYY-MM-DD')
        },
        fechaDeEnvioJuzgado: null,
        visorDomicilio: {
          mostrar: false,
          REF: 'REFVisorDomicilioVDDC',
          ID: 'VisorDomicilioVDDC',
          POSICION_ORIGEN: [21.878305650330997,-102.29601653410975],
          ACERCAMIENTO: 14
        },
        esNotificador: false,
        visorResultado: {
          contRender: 0
        },
        infBasicaCedula: {
          REF: 'InformacionBasicaDeCedulaREF'
        },
        domicilioConFraccionamientoFueraDeCatalogo: false
      }
     },
    props: {
      FolioCedula: Number
    },  
    methods: {
      actualizarVisoresDeDocumentos: function() {
        this.visorDocumentoCedula.contRender ++;
        this.visorResultado.contRender ++;
      },
      mostrarConfirmacionEliminarResultadoDeCedula: function({ mostrar }) {
        let accion = (mostrar) ? 'show' : 'hide';
        $("#modal-informativo").modal(accion);
      },
      eliminarResultadoDeCedula: async function() {
        try {
          const SERVIDOR = api.conexion;
          const METODO_API_ELIMINAR = api.SINOJ.sistema.consultas.consultaDireccion.EliminarResultadosDeCedulas;
          let urlApi = SERVIDOR + METODO_API_ELIMINAR;
          let peticionArchivos = false;
          let peticionAPI = {
            Cedulas: [this.cedulaBD],
            esPrueba: false
          };
          let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
          this.mostrarConfirmacionEliminarResultadoDeCedula({ mostrar: false });
          comun.SeEstaCargandoInformacion(true);
          const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticionAPI, headerPeticion);
          const DATOS = await RESPUESTA_SOLICITUD.data;
          let { SiHayError, Error, Satisfactorio, Cedulas } = DATOS;
          if (SiHayError) {
              let mensajeError = Error.Mensaje;
              comun.SeEstaCargandoInformacion(false);
              console.log(Error);
              comun.mensajeDeAlerta(mensajeError, null, null);
          } 
          else {
            // se limpian las variables actuales del resultado de la cedula
            this.cedulaBD.Resultado = null;
            this.asignarValoresDeResultado();
            this.documentoResultado = [];
            this.documentosResultadoCompleto = [];
            comun.SeEstaCargandoInformacion(false);
            
            // en caso de que la cedula este seleccionada para enviar a juzgado en vista previa se remueve de la lista
            // padre de consulta de direccion
            let cedulasSelccionadasVistaPadre = this.obtenerCedulasSeleccionadasPrevias.map(c => {
              if(c.folio == this.cedulaBD.CedulaId) {
                c.enviar = false;
              }
              return c;
            });
            this.A_SINOJ_establecerCedulasSeleccionadas_ConsultaDeDireccion(cedulasSelccionadasVistaPadre);
            let solicitudeDeEnvioVistaPadre = this.obtenerSolicitudDeCedulasPrevia.filter(c => c.Folio != this.cedulaBD.CedulaId);
            this.A_SINOJ_establecerCedulasDeSolicitud_ConsultaDeDireccion(solicitudeDeEnvioVistaPadre);

            // se deshabilita la pestaña para el envio a juzagdo porque la cedula vuelve a quedar sin resultado
            comun.mensajeDeAlerta(Satisfactorio);
            this.$nextTick(() => {
                $("#enviarCedula-consulta-tab").addClass('disabled');
                this.cedulaBD.Estatus.Nombre = Cedulas[0].Estatus.Nombre;
            });
          }
        }
        catch(excepcion) {
          comun.SeEstaCargandoInformacion(false);
          console.log(excepcion);
          comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
        }
      },
      evtMostrarVisorDomicilio: function() {
        this.visorDomicilio.mostrar = !this.visorDomicilio.mostrar;
        if(this.visorDomicilio.mostrar) {
          // se carga domicilio en el visualizador
          this.$nextTick(async () => {
              comun.SeEstaCargandoInformacion(true);
              await Promise.resolve(this.visualizarDomicilioEnMapa())
              comun.SeEstaCargandoInformacion(false);
          });
        }
      },
      visualizarDomicilioEnMapa: async function() {
          if(this.campoRequeridoEsValido(this.domicilio)) {
              this.$refs[this.visorDomicilio.REF].obtenerCoordenadasPorCalleCompleta(this.domicilio);
          }
      },
      iniciarProcesoDeEnvioAJuzgado: async function() {
        const DIA_ACTUAL = moment().format('YYYY-MM-DD');
        if(this.formularioEnvioAJuzgado.fechaDeEnvioJuzgado < DIA_ACTUAL) {
          comun.mensajeDeAlerta('Fecha de envio incorrecta,<br>No se puede enviar una cédula al juzgado con una fecha menor al dia de hoy');
        }
        else {
          this.enviarCedulasAJuzgado();
        }
      },
      enviarCedulasAJuzgado: function() { 
        const SERVIDOR = api.conexion;
        const METODO_API_ACTUALIZAR = api.SINOJ.sistema.consultas.consultaDireccion.EnviarCedulasAJuzgado;
        let urlApi = SERVIDOR + METODO_API_ACTUALIZAR;
        let peticionArchivos = false;
        let peticionAPI = {};
        peticionAPI.Cedulas = [
          {
            CedulaId: this.cedulaBD.CedulaId,
            FechaDeRegistro: moment().format('YYYY-MM-DD'),
            FechaDeEnvioAJuzgado: this.formularioEnvioAJuzgado.fechaDeEnvioJuzgado
          }
        ]
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
        comun.SeEstaCargandoInformacion(true);
        axios.post(urlApi, peticionAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        let mensajeError = respuesta.data.Error.Mensaje;
                        console.log(mensajeError);
                        comun.mensajeDeAlerta(mensajeError, null, null);
                    } 
                    else {
                      // Se limpian variables relacionadas con las solicitudes de envio a juzgado
                      const CEDULAS = respuesta.data.Cedulas;
                      if(CEDULAS != null && CEDULAS.length > 0) {
                        const CEDULA = CEDULAS[0];
                        this.fechaDeEnvioJuzgado = moment(CEDULA.FechaDeEnvioAJuzgado).format(this.FORMATO_FECHA);
                        let cedulasSelccionadasVistaPadre = this.obtenerCedulasSeleccionadasPrevias.map(c => {
                          if(c.folio == this.cedulaBD.CedulaId) {
                            c.enviar = false;
                          }
                          return c;
                        });
                        this.A_SINOJ_establecerCedulasSeleccionadas_ConsultaDeDireccion(cedulasSelccionadasVistaPadre);
                        let solicitudeDeEnvioVistaPadre = this.obtenerSolicitudDeCedulasPrevia.filter(c => c.Folio != this.cedulaBD.CedulaId);
                        this.A_SINOJ_establecerCedulasDeSolicitud_ConsultaDeDireccion(solicitudeDeEnvioVistaPadre);
                        if(CEDULA.FechaDeEnvioAJuzgado != null) {
                          this.$nextTick(() => {
                              $("#regresarCedula-consulta-tab").addClass('disabled');
                          });
                          this.cedulaBD.FechaDeEnvioAJuzgado = CEDULA.FechaDeEnvioAJuzgado;
                        }
                      }
                      comun.SeEstaCargandoInformacion(false);
                      comun.mensajeDeAlerta('La cédula fue enviada correctamente al juzgado');
                    }
                })
                .catch(excepcion => {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                    comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                }
        ); 
      },
      evtRegresarCedulaAJuzgado: function() {
        this.informarConfirmacionDeEliminar(this.cedulaBD.CedulaId);
      },
      regresarCedulaBD: function(cedulaId) {
        const SERVIDOR = api.conexion;
        const METODO_API_REGRESAR = api.SINOJ.sistema.consultas.consultaDireccion.RegresarCedulaAJuzgado;
        let urlApi = SERVIDOR + METODO_API_REGRESAR ;
        let peticionArchivos = false;
        let peticionAPI = {
          Cedula: { CedulaId: cedulaId, MotivosDeDevolucion: (this.campoRequeridoEsValido(this.motivosDeRegreso)) ? this.motivosDeRegreso : null },
          esPrueba: false
        }
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
        comun.SeEstaCargandoInformacion(true);
        axios.post(urlApi, peticionAPI, headerPeticion)
            .then(respuesta => {            
                if (respuesta.data.SiHayError) {
                  let mensajeError = respuesta.data.Error.Mensaje;
                  console.log(mensajeError);
                  comun.mensajeDeAlerta(mensajeError, null, null);
                } 
                else {
                  //this.regresarAVistaPrincipal();
                    this.$nextTick(() => {
                        $("#regresarCedula-consulta-tab").addClass('disabled');
                        $("#enviarCedula-consulta-tab").addClass('disabled');
                        $("#documento-cedula-tab").trigger('click');
                    });
                  comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                  this.regresarAVistaPrincipal();
                }
                comun.SeEstaCargandoInformacion(false);
            })
            .catch(excepcion => {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        ); 
      },
      evtDetallesHistorial: function(evento) {
        const ACUERDO_SELECCIONADO = evento.target.getAttribute('id');
        const ID_BUSQUEDA = parseInt(this.obtenerIdElementoSeleccionado(ACUERDO_SELECCIONADO));
        /* let acuerdo = null;
        this.cedulaBD.Expediente.Acuerdos.filter(a => {
          acuerdo = a;
          acuerdo.Expediente = {
            Juzgado: this.cedulaBD.Expediente.Juzgado,
            TipoDocumento: this.cedulaBD.Expediente.TipoDocumento,
            NumeroDeDocumento: this.cedulaBD.Expediente.NumeroDeDocumento
          }
        }); */
        console.log('idAcuerdo::',ID_BUSQUEDA);
        let acuerdo = this.cedulaBD.Acuerdos.find(a => a.AcuerdoIdReferencia == ID_BUSQUEDA);
        if(acuerdo != null) {
          acuerdo.Expediente = {
            Juzgado: this.cedulaBD.Expediente.Juzgado,
            TipoDocumento: this.cedulaBD.Expediente.TipoDocumento,
            NumeroDeDocumento: this.cedulaBD.Expediente.NumeroDeDocumento
          }
          router.push({ name: "HistorialDeAcuerdoConsultaDireccion", params: { folio: acuerdo.AcuerdoIdReferencia, acuerdo: acuerdo, cedulaSeleccionada: this.cedulaBD.CedulaId } });
        }
      },
     /*  evtVerAnexo: function(evento) {
        const DOCUMENTO_SELECCIONADO = evento.target.getAttribute('id');
        const INDEX_DOCUMENTO = parseInt(this.obtenerDocumentoResultadoSeleccionado(DOCUMENTO_SELECCIONADO));
        console.log('endexxxx::',this.documentosResultadoCompleto);
        this.docResultadoSeleccionado = (INDEX_DOCUMENTO - 1);
      },
      obtenerDocumentoResultadoSeleccionado: function(documento) {
        const DOCUMENTO = documento.split('-');
        const POSICION_ID = (DOCUMENTO.length - 1);
        const ID_DOCUMENTO = DOCUMENTO[POSICION_ID];
        return ID_DOCUMENTO;
      }, */
      obtenerIdElementoSeleccionado: function(elemento) {
        const ELEMENTO = elemento.split('-');
        const POSICION_ID = (ELEMENTO.length - 1);
        const ID_ELEMENTO = ELEMENTO[POSICION_ID];
        return ID_ELEMENTO;
      },
      regresarAVistaPrincipal: function() {
        let tieneFiltroPrevios = Object.values(this.filtrosPreviosVistaResultado).some(f => this.campoRequeridoEsValido(f));
        this.filtrosPreviosVistaResultado.cargarConFiltros = tieneFiltroPrevios;
        const VARIBALES_VISTAS_CD = {
          filtrosPrevios: this.filtrosPreviosVistaResultado,
          cedulaSeleccionada: null,
          obtenerCedulas: true
        };
        this.A_SINOJ_establecerConsultaDeDireccion_Variables(VARIBALES_VISTAS_CD);
        router.push({ name: "ConsultaDireccion" });
      },
      campoRequeridoEsValido: function(campo) { 
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'array' || campo instanceof Array) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo.length > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
      verDocumento: function() {
        debugger
      },
      verHistorialDeAcuerdo: function (){                
        router.push({ name: "HistorialDeAcuerdoConsultaDireccion", params: { FolioCedula: this.cedula.Folio } })
      },
      obtenerIconoDeNivelUrgencia: function(idEstado) {
        switch(idEstado) {
          case enumeraciones.sinoj.estadosNivelDeUrgencia.Rojo:
            this.prioridadCedula = 'ALTA';
            this.iconoPrioridad = `<i class="fa fa-circle text-rigth text-danger" style="font-size: 1.3em;"></i>`;
          break;
          case enumeraciones.sinoj.estadosNivelDeUrgencia.Amarillo:
            this.prioridadCedula = 'MEDIA';
            this.iconoPrioridad = `<i class="fa fa-circle text-rigth text-warning" style="font-size: 1.3em;"></i>`;
          break;
          case enumeraciones.sinoj.estadosNivelDeUrgencia.Verde:
            this.prioridadCedula = 'BAJA';
            this.iconoPrioridad = `<i class="fa fa-circle text-rigth text-success" style="font-size: 1.3em;"></i>`;
          break;
          default:
            break;
        }
      },
      obtenerNombreNotificador: function(notificador) {
        const { Usuario } = notificador;
        const DATOS_DE_NOMBRE = [Usuario.Nombre, Usuario.ApellidoPaterno, Usuario.ApellidoMaterno];
        return DATOS_DE_NOMBRE.join(' ');
      },
      obtenerNombreArchivoDeCedula: function() {
        if(this.campoRequeridoEsValido(this.cedulaBD.ArchivoRuta)) {
            this.visorDocumentoCedula.url = this.cedulaBD.ArchivoRuta;
            const RUTA_ARCHIVO = this.cedulaBD.ArchivoRuta.split('\\');
            const NOMBRE_ARCHIVO = RUTA_ARCHIVO[RUTA_ARCHIVO.length -1];
            this.nombreArchivoDeCedula =` ${NOMBRE_ARCHIVO}`;
        }
      },
      darFormatoTablaAListaObjetos: function(listaDeObjetos, tipo) {
        let documentoPrincipalResultado = tipo.tieneDocumentoPrincipal;
        let listaConFormato = listaDeObjetos.map(obj => {
          let objetoConFormato = null;
          if(tipo.nombre == 'RESULTADO') { // valida que sean objetos de tipo resultado (Principal y anexos)
            if(documentoPrincipalResultado) { // agrega como primer elemento e documento principal del resultado
              objetoConFormato = obj;
              documentoPrincipalResultado = false;
            }
            else { // agrega despues del documento principal los anexos
              objetoConFormato = this.anexoAFormatoTabla(obj);
            }
          } 
          else if(tipo.nombre == 'ACUERDO') {
            objetoConFormato = this.acuerdoAFormatoTabla(obj);
          }
          return objetoConFormato;
        });
        return listaConFormato;
      },
      anexoAFormatoTabla: function(anexo) {
        let anexoObj = {};
        anexoObj.Folio = this.contAnexos += 1;
        anexoObj.tipo = 'Anexo';
        const RUTA_ARCHIVO = anexo.AnexoRuta.split('\\');
        const NOMBRE_ARCHIVO = RUTA_ARCHIVO[RUTA_ARCHIVO.length -1];
        anexoObj.nombre = `${NOMBRE_ARCHIVO}`;
        return anexoObj;
      },
      acuerdoAFormatoTabla: function(acuerdo) { debugger
        // 'Folio', 'Extracto', 'Fecha de publicación','Fecha de audiencia','Acuerdo principal'
        let { AcuerdoIdReferencia, EsPrincipal, Extracto, FechaDeAudiencia, FechaDePublicacion } = acuerdo;
        let acuerdoObj = {};
        acuerdoObj.Folio = AcuerdoIdReferencia;
        acuerdoObj.Extracto = (this.campoRequeridoEsValido(Extracto)) ? Extracto : 'Sin Extracto';
        acuerdoObj.FechaPublicacion = (this.campoRequeridoEsValido(FechaDePublicacion)) ? moment(FechaDePublicacion).format(this.FORMATO_FECHA) : 'Sin fecha de publicacion';
        acuerdoObj.FechaAudiencia = (this.campoRequeridoEsValido(FechaDeAudiencia)) ? moment(FechaDeAudiencia).format(this.FORMATO_FECHA) : 'Sin fecha de audiencia';
        acuerdoObj.EsPricipal = (this.campoRequeridoEsValido(EsPrincipal) && EsPrincipal) ? 'SI' : 'NO';
        return acuerdoObj;
      },
      asignarValoresDeResultado: function() { debugger
        if(this.campoRequeridoEsValido(this.cedulaBD)) {
          let { Resultado } = this.cedulaBD;
          if(this.campoRequeridoEsValido(Resultado)) {
            this.fechaResultado = this.campoRequeridoEsValido(Resultado.FechaResultado) ? moment(Resultado.FechaResultado).format(this.FORMATO_FECHA) : 'Sin fecha de resultado'; 
            this.tipoResultado = this.campoRequeridoEsValido(Resultado.TipoResultado) ? Resultado.TipoResultado.Nombre : 'Sin resultado';
            this.tipoRazon = this.campoRequeridoEsValido(Resultado.TipoRazon) ? Resultado.TipoRazon.Nombre : null;
            this.observacionesResultado = this.campoRequeridoEsValido(Resultado.ObservacionesResultado) ? Resultado.ObservacionesResultado : null;
          }
          else {
            this.fechaResultado = 'Sin fecha de resultado'; 
            this.tipoResultado = 'Sin resultado';
            this.tipoRazon = null;
            this.observacionesResultado = null;
          }
        }
      },
      asignarValoresDeDocumentoResultado: async function(resultado) { 
        comun.SeEstaCargandoInformacion(true);
        let { Anexos } = resultado;
        let principales = [];
        /* let anexos = []; */
        let tipo = { nombre: 'RESULTADO', tieneDocumentoPrincipal: false };
        if(this.campoRequeridoEsValido(this.cedulaBD.Resultado) && this.campoRequeridoEsValido(this.cedulaBD.Resultado.ArchivoResultado_Ruta)) {
          let documentoPrincipal = {};
          documentoPrincipal.Folio = this.contAnexos += 1;
          documentoPrincipal.tipo = 'principal';
          const RUTA_ARCHIVO = this.cedulaBD.Resultado.ArchivoResultado_Ruta.split('\\');
          const NOMBRE_ARCHIVO = RUTA_ARCHIVO[RUTA_ARCHIVO.length -1];
          documentoPrincipal.nombre = `${NOMBRE_ARCHIVO}`;
          principales.push(documentoPrincipal);
          tipo.tieneDocumentoPrincipal = true;
        }
        if(this.campoRequeridoEsValido(Anexos)) {
          for(let i=0; i<Anexos.length; i++) {
            Anexos[i].archivo = await this.descargarArchivo(Anexos[i].AnexoRuta);
          }
        }
        else {
          Anexos = [];
        }
        this.documentosResultadoCompleto = principales.concat(Anexos);
        //console.log('anexosConArchivo::',this.documentosResultadoCompleto);
        this.documentoResultado = (this.documentosResultadoCompleto.length > 0) ? this.darFormatoTablaAListaObjetos(this.documentosResultadoCompleto,tipo) : [];
        comun.SeEstaCargandoInformacion(false);
      },
      descargarArchivo: async function(rutaArchivo) {
        let archivo = null;
        const METODO_DESCARGA = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${rutaArchivo}`;
        try {
          if(this.campoRequeridoEsValido(rutaArchivo)) {
            const PETICION_DESCARGA = await axios.get(METODO_DESCARGA, { responseType: 'blob' });
            const ARCHIVO_DESCARGADO = await PETICION_DESCARGA.data;
            let tipoArchivo = ARCHIVO_DESCARGADO.type;
            // para pdf la API regresa un blob tipo application/octet-stream con arrayBuffer que no adminte el Object html del visos.
            // solo hay que cambiar el tipo a uno que admita el cual es 'application/pdf'. 
            if(this.campoRequeridoEsValido(tipoArchivo) && tipoArchivo.startsWith('application/octet-stream')) {
              tipoArchivo = 'application/pdf';
            }
            archivo = new File([ARCHIVO_DESCARGADO], 'archivoAnexo', { type: tipoArchivo });
          }
        }
        catch(exeption) {
          console.log(exeption);
        }
        return archivo;
      },
      asignarValoresAcuerdos: function(acuerdos) {
        const TIPO = { nombre: 'ACUERDO', tieneDocumentoPrincipal: null };
        this.acuerdosDeCedulaBD  = this.darFormatoTablaAListaObjetos(acuerdos, TIPO);
      },
      informarConfirmacionDeEliminar: function (cedulaId) {
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: `Estas seguro que deseas regresar la cédula  [ folio: #${cedulaId} ]<br>¿Desea continuar?`,
          buttons: {
            cancel: {
                label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
            },
            confirm: {
                label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
            }
          },
          callback: (respuesta) => {
            if (respuesta) {
                this.regresarCedulaBD(cedulaId);
            }
          }
        });
      },
      iniciarProcesoCargaInformacionDeCedula: async function() {
        const PETICION_API = { Cedula: this.cedulaBD, esPrueba: false };
        const PROCESO_SIN_ERROR = await Promise.resolve(this.cargarInformacionDeCedula({ peticion: PETICION_API }));
        if(!PROCESO_SIN_ERROR) {
          router.push({ name: "ConsultaDireccion"});
        }
      },
      cargarInformacionDeCedula: async function({ peticion, conMensajeDeRespuesta = false }) { 
            let procesoSinError = false;
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SINOJ.sistema.consultas.consultaDireccion.CargarInformacionDeCedula;
                const URL_API_SERVICIO = SERVIDOR + METODO_API_OBTENER;
                const HEADER_PARA_ENVIO_ARCHIVOS = false;
                const HEADER_PARA_ARRAY_BUFFER = false;
                const HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS,HEADER_PARA_ARRAY_BUFFER);
                comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(URL_API_SERVICIO, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, Cedula, Satisfactorio } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                } 
                else { 
                    this.cedulaBD = Cedula;
                    procesoSinError = true;
                    if(conMensajeDeRespuesta && this.campoRequeridoEsValido(Satisfactorio))
                        comun.mensajeDeAlerta(Satisfactorio);
                }
                comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return procesoSinError;
        },
      ...mapActions([
        'A_SINOJ_establecerConsultaDeDireccion_Variables',
        'A_SINOJ_establecerCedulasSeleccionadas_ConsultaDeDireccion',
        'A_SINOJ_establecerCedulasDeSolicitud_ConsultaDeDireccion'
      ]) 
    },
    mounted() {
      // observador para el cambio de pagina de la tabla de documentos de resultado
      this.$watch(
        () => { debugger
          return this.$refs[this.REF_T_ANEXOS].pagina
        },
        (numeroDePagina) => { debugger
          this.docResultadoSeleccionado = (numeroDePagina - 1);
          this.visorResultado.contRender ++;
        }
      );

      if(this.campoRequeridoEsValido(this.cedulaBD)) {
        if(this.campoRequeridoEsValido(this.cedulaBD.Resultado)) {
          this.asignarValoresDeDocumentoResultado(this.cedulaBD.Resultado);
        }
      }
    },
    async created() { 
        const PARAMETROS_VISTA = this.obtenerVariablesDeVista;
        if(!this.campoRequeridoEsValido(PARAMETROS_VISTA) || !this.campoRequeridoEsValido(PARAMETROS_VISTA[this.ATRIBUTO_CEDULA])) {
            router.push({ name: "ConsultaDireccion"});
        }
        else {
            console.log('parametros::',PARAMETROS_VISTA);
            // si el suario es de un juzgado mixto se deshabilitan las pestanas para el regreso de cedulas al juzagdp
            if(PARAMETROS_VISTA.esJuzgadoMixto) {
              this.$nextTick(() => {
                  $("#enviarCedula-consulta-tab").addClass('disabled');
                  $("#regresarCedula-consulta-tab").addClass('disabled');
              });
            }

            this.cedulaBD = PARAMETROS_VISTA[this.ATRIBUTO_CEDULA];
            await Promise.resolve(this.iniciarProcesoCargaInformacionDeCedula());
            this.visorDocumentoCedula.contRender ++;
            if(this.campoRequeridoEsValido(this.cedulaBD.Resultado)) {
              this.asignarValoresDeDocumentoResultado(this.cedulaBD.Resultado);
            }
            this.filtrosPreviosVistaResultado = PARAMETROS_VISTA[this.ATRIBUTO_FILTROS];
            this.fechaEnvioDireccion = moment(this.cedulaBD.FechaDeEnvio).format(this.FORMATO_FECHA);
            this.obtenerIconoDeNivelUrgencia(this.cedulaBD.NivelDeUrgencia);
            this.domicilio = 'Sin domicilio';
            if(this.campoRequeridoEsValido(this.cedulaBD.PersonasANotificar)) {
              if(this.cedulaBD.PersonasANotificar[0].Domicilios != null && this.cedulaBD.PersonasANotificar[0].Domicilios.length > 0) {
                  const DOMICILIO_OBJ = this.cedulaBD.PersonasANotificar[0].Domicilios[0];
                  let infAdicionalNumExt = (this.campoRequeridoEsValido(DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior)) ? ` ${ DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior }` : '';
                  let numInterior = (this.campoRequeridoEsValido(DOMICILIO_OBJ.NumeroInterior)) ? `int ${ DOMICILIO_OBJ.NumeroInterior.toString().trim() }` : '';
                  if(this.campoRequeridoEsValido(DOMICILIO_OBJ.Fraccionamiento)) {
                      this.domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ DOMICILIO_OBJ.Fraccionamiento.Nombre }, ${ DOMICILIO_OBJ.Fraccionamiento.Municipio.Nombre }`;
                  }
                  else {
                      /* 
                          para los casos de domicilios con fraccionamiento que no pertenece al catalogo de fraccionamientos, se guarda la informacion el un solo campo (008FraccionamientoFueraDeCatalogo => FraccionamientoFueraDeCatalogo)
                          con el siguiente formato NOMBRE_FRACCIONAMIENTO, NOMBRE_MUNICIPIO, si se modifica posteriormenete este formato se tendra que reemplazar esta 
                          logica.
                        */
                      this.domicilioConFraccionamientoFueraDeCatalogo = true;
                      let fraccionamientoCompuesto = DOMICILIO_OBJ.FraccionamientoFueraDeCatalogo.split(',');
                      let nombreFraccionamiento = fraccionamientoCompuesto[0];
                      let nombreMunicipio = fraccionamientoCompuesto[1];
                      this.domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ nombreFraccionamiento }, ${ nombreMunicipio }`;
                  }

                /*  const DOMICILIO_OBJ = this.cedulaBD.PersonaANotificar.Domicilios[0];
                  let infAdicionalNumExt = (this.campoRequeridoEsValido(DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior)) ? ` ${ DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior }` : '';
                  let numInterior = (this.campoRequeridoEsValido(DOMICILIO_OBJ.NumeroInterior)) ? `int ${ DOMICILIO_OBJ.NumeroInterior.toString().trim() }` : '';
                  this.domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ DOMICILIO_OBJ.Fraccionamiento.Nombre }, ${ DOMICILIO_OBJ.Fraccionamiento.Municipio.Nombre }`; */
              }
            }
            if(this.campoRequeridoEsValido(this.cedulaBD.Expediente)) {
              if(this.cedulaBD.Expediente.Acuerdos != null && this.cedulaBD.Expediente.Acuerdos.length > 0) {
                let acuerdoPrincipal = this.cedulaBD.Expediente.Acuerdos.find(a => a.EsPrincipal);
                if(acuerdoPrincipal != null && acuerdoPrincipal != undefined) {
                  this.fechaAudiencia = this.campoRequeridoEsValido(acuerdoPrincipal.FechaDeAudiencia) ? moment(acuerdoPrincipal.FechaDeAudiencia).format(this.FORMATO_FECHA) : 'Sin fecha de audiencia';
                }
              }
            }
            this.nombreNotificador = (this.campoRequeridoEsValido(this.cedulaBD.Notificador)) ? this.obtenerNombreNotificador(this.cedulaBD.Notificador) : 'La cédula no cuenta con notificador asignado';
            this.fechaAsignacion = (this.campoRequeridoEsValido(this.cedulaBD.Notificador) && this.cedulaBD.AsignacionesDeNotificador.length > 0) ? moment(this.cedulaBD.AsignacionesDeNotificador[0].FechaDeAsignacion).format(this.FORMATO_FECHA) : 'Sin fecha';
            this.fechaCreacion = (this.campoRequeridoEsValido(this.cedulaBD.FechaDeRegistro)) ? moment(this.cedulaBD.FechaDeRegistro).format(this.FORMATO_FECHA) : 'Sin fecha';
            this.obtenerNombreArchivoDeCedula();
            this.asignarValoresDeResultado();
            if(this.campoRequeridoEsValido(this.cedulaBD.Expediente)) {
              this.numeroExpediente = this.cedulaBD.Expediente.NumeroDeDocumento;
              this.asignarValoresAcuerdos(this.cedulaBD.Acuerdos);
              console.log('Acuerdos::',this.cedulaBD.Acuerdos)
            }
            this.esNotificador = PARAMETROS_VISTA.esNotificador;
            if(PARAMETROS_VISTA.esNotificador || this.cedulaBD.Estatus.Nombre == 'Regresada') {
              this.$nextTick(() => {
                  $("#enviarCedula-consulta-tab").addClass('disabled');
                  $("#regresarCedula-consulta-tab").addClass('disabled');
              });
            }
            if(!this.campoRequeridoEsValido(this.cedulaBD.Resultado)) {
              this.$nextTick(() => {
                  $("#enviarCedula-consulta-tab").addClass('disabled');
              });
            }
            this.fechaDeEnvioJuzgado = (this.campoRequeridoEsValido(this.cedulaBD.FechaDeEnvioAJuzgado)) ? moment(this.cedulaBD.FechaDeEnvioAJuzgado).format(this.FORMATO_FECHA) : null;
            if(this.fechaDeEnvioJuzgado != null) {
              this.$nextTick(() => {
                  $("#regresarCedula-consulta-tab").addClass('disabled');
              });
            }
            console.log('cedula::',this.cedulaBD);
            //console.log('filtros::',this.filtrosPreviosVistaResultado);
        }
    },
    computed: {
      obtenerVariablesDeVista() {
        return this.$store.getters.Get_SINOJ_ConsultaDeDireccion_Variables;
      },
      obtenerCedulasSeleccionadasPrevias() {
        return this.$store.getters.Get_SINOJ_CedulasSeleccionadas_ConsultaDeDireccion;
      },
      obtenerSolicitudDeCedulasPrevia() {
        return this.$store.getters.Get_SINOJ_CedulasDeSolicitud_ConsultaDeDireccion;
      }
    },
    watch: {
        documentoResultado() {
            if(this.documentoResultado.length > 0) {
                this.$refs[this.REF_T_ANEXOS].cedulasAmostrarPorPagina = 1;
            }
        },
        docResultadoSeleccionado() { debugger
          if(this.docResultadoSeleccionado < 1) {
            this.vaDocResultado = 'Visualizando doc principal'
          }
          else {
            this.vaDocResultado = 'Visualizando doc anexo'
          }
        }
    },
    beforeRouteLeave (to, from, next) {
        const VISTA_PADRE = 'ConsultaDireccion';
        const VISTA_HIJA  = 'HistorialDeAcuerdoConsultaDireccion';
        if(to.name != VISTA_PADRE && to.name != VISTA_HIJA) {
          this.A_SINOJ_establecerConsultaDeDireccion_Variables(null);
        }
        next();
    }
  }
</script>
<style scoped>
  #modal-informativo .modal-lg {
      max-width: 30% !important;
  }

  #modal-informativo .modal-header {
      background-color: rgb(36, 34, 34);;
      border: none;
  }

  #modal-informativo .modal-dialog {
    position: relative;
    top: 40%;
    transform: translateY(-50%);
  }

  textarea {
      padding: 0.6em !important;
  }

  #encabezado-contenedor-contenido {
    background-color: var(--verde-pj);
    padding: 10px;
  }

  #encabezado-contenedor-contenido h4 {
    color: #ffff !important;
  }

  #encabezado-contenedor-contenido .btn {
    background-color: var(--verde-pj-100);
    padding-left: 15px;
    padding-right: 15px;
  }

  .contenedor-informacion {
    background-color: var(--gris-pj-100);
    padding: 25px;
  }

  .contenedor-color-negro {
      padding: 1.5em;
      background-color: var(--blanco-pj);
      /* box-shadow: 0px 6px 20px 8px #161616; */
  }

  .contenedor-tab {
    box-shadow: 0px 6px 20px 8px #161616;
    padding: 25px;
  }  

  .nav_tab_formularios {
    padding: 25px;
    background-color: var(--gris-pj-100);
    /* box-shadow: 0px 6px 20px 4px #161616; */
  }

  .nav-tabs {
    border-bottom: 1px solid white;
  }

  .nav-link {
    background-color: var(--verde-pj);
  }

  .nav-item > a.active,
  .nav-item > a.active:focus,
  .nav-item > a.active:hover {
    background-color: var(--verde-pj-100);
    color: white;
    border-bottom: 1px solid #2c2d31;
  }

  .nav-item > a {
    border-bottom: 1px white;
  }

  #seccion-visor-domicilio .btn-sm {
    padding: 0.5px 5px 0px 5px;
  }

  #contenedor-mapa {
    height: 410px;
    width: 100%;
    margin-top: 1em;
  }

  #regresarCedula_btn {
    background-color: var(--verde-pj-100) !important;
  }
</style>
<style>
#DetallesConsultaDireccion_div .form-control {
        background-color: white !important;
        color: black !important;
    }


#DetallesConsultaDireccion_div .area {
  background-color: #bebebc !important;
}

#DetallesConsultaDireccion_div .area h6 {
  color: black !important;
} 
</style>



// WEBPACK FOOTER //
// src/components/SINOJ/Consultas/ConsultaDireccion/DetallesCedula.vue